<template>
  <div
    id="mobile-menu"
    ref="MainMenu"
    class="absolute left-0 w-full overflow-hidden transition-all duration-300 ease-in-out bg-white shadow-lg opacity-0 md:hidden top-full max-h-0"
  >
    <div class="px-4 pt-2 pb-6 space-y-2 border-t border-gray-100">
      <router-link
        to="/news"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >最新消息</router-link
      >
      <router-link
        to="/knowledge"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >醫學專欄</router-link
      >
      <router-link
        to="/about"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >關於我們</router-link
      >
      <router-link
        to="/doctors"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >醫師團隊</router-link
      >
      <router-link
        to="/hours"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >門診時間</router-link
      >
      <router-link
        to="/services"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >診療項目</router-link
      >
      <router-link
        to="/progress"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >看診進度</router-link
      >
      <router-link
        to="/traffic"
        @click.native="openStatus = false"
        class="block px-3 py-3 text-base font-medium rounded-md text-slate-700 hover:text-brand-blue hover:bg-sky-50 mobile-link"
        >交通資訊</router-link
      >
      <a
        :href="`tel:${$store.getters.getThemeColumn('company_phone')}`"
        @click="openStatus = false"
        class="flex items-center justify-center gap-2 px-4 py-3 mt-4 font-medium text-white rounded-md bg-brand-blue"
      >
        <i data-lucide="phone" class="w-4 h-4"></i>
        <span>撥打電話預約</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainMenu",
  data() {
    return {
      openStatus: false,
    };
  },
  methods: {
    openMenu() {
      this.$refs.MainMenu.classList.remove("max-h-0", "opacity-0");
      this.$refs.MainMenu.classList.add("max-h-[528px]", "opacity-100");
    },
    closeMenu() {
      this.$refs.MainMenu.classList.add("max-h-0", "opacity-0");
      this.$refs.MainMenu.classList.remove("max-h-[528px]", "opacity-100");
    },
    setMenuOpenStatus(status) {
      this.openStatus = status;
    },
  },
  watch: {
    openStatus(newVal) {
      if (newVal) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.openStatus = false;
    });
  },
};
</script>
